import React from 'react';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="strokeGradient" gradientTransform="rotate(90)">
            <stop offset="5%" stopColor="#2276FC" />
            <stop offset="55%" stopColor="#2276FC" />
          </linearGradient>
        </defs>
        <path
          className="pulse"
          d="M25 50V20 M75 50V20 M25 50H40L45 40L50 60L55 30L60 50H75"
          strokeWidth="5"
          stroke="url(#strokeGradient)"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default Loader;
